export const RoutesApp = {
  LOGIN: '/login',
  REGISTER: '/register',
  //Private
  HOME: '/home/:action?',
  TOOLS: '/herramientas',
  WAREHOUSE_TOOLS: '/bodega-herramientas',
  RAW_MATERIALS: '/materia-primas',
  WAREHOUSE: '/bodega',
  RECEIPTS: '/recetas',
  BLOCK: '/bloque',
  CLIENTS: '/clientes',
  CLIENT: '/clientes/:uid',
  DASHBOARD: '/dashboard',
  PROFORMAS: '/proformas',
  PROFORMA_FORM: '/proformas/form/:uid?',
  PROFORMA_VIEW: '/proformas/view/:uid',
  GEO_CHECKPOINTS: '/geolocalizaciones',
  EXPORT: '/exportar',
  ORDER_PURCHASES: '/ordenes-compra',
  ORDER_PURCHASES_FORM: '/ordenes-compra/form/:uid?',
  ORDER_PURCHASES_VIEW: '/ordenes-compra/view/:uid',
  //Public
  ROOT: '/',
}
